import { Flex } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import ListSection from "./ListSection";

const SECTION_WIDTH = 1250;

export default function DiscoveryUSPs() {
  const { t } = useTranslation();

  return (
    <Flex id="about" direction="column" alignItems={"center"}>
      <Flex
        alignItems={"center"}
        maxWidth={SECTION_WIDTH}
        width={"100%"}
        direction={"column"}
      >
        <ListSection
          title={t("Discovery.USP.Header")}
          items={[
            {
              text: t("Discovery.USP.USP1"),
            },
            {
              text: t("Discovery.USP.USP2"),
            },
            {
              text: t("Discovery.USP.USP3"),
            },
          ]}
        ></ListSection>
      </Flex>
    </Flex>
  );
}
